module.exports = __webpack_public_path__ + "media/assets/images/votorantim-azul-1f5d664946269357ab2dd346f6cfdd9d.svg";